export var ArticleSortType;
(function (ArticleSortType) {
    ArticleSortType[ArticleSortType["CREATION_DATE_ASC"] = 10] = "CREATION_DATE_ASC";
    ArticleSortType[ArticleSortType["CREATION_DATE_DESC"] = 20] = "CREATION_DATE_DESC";
    ArticleSortType[ArticleSortType["LAST_UPDATE_DATE_ASC"] = 30] = "LAST_UPDATE_DATE_ASC";
    ArticleSortType[ArticleSortType["LAST_UPDATE_DATE_DESC"] = 40] = "LAST_UPDATE_DATE_DESC";
    ArticleSortType[ArticleSortType["POSITION"] = 50] = "POSITION";
    ArticleSortType[ArticleSortType["LINKED_TICKETS_COUNT_ASC"] = 60] = "LINKED_TICKETS_COUNT_ASC";
    ArticleSortType[ArticleSortType["LINKED_TICKETS_COUNT_DESC"] = 70] = "LINKED_TICKETS_COUNT_DESC";
    ArticleSortType[ArticleSortType["TEXTUAL_SCORE"] = 100] = "TEXTUAL_SCORE";
    ArticleSortType[ArticleSortType["FIRST_PUBLISH_DATE_ASC"] = 110] = "FIRST_PUBLISH_DATE_ASC";
    ArticleSortType[ArticleSortType["FIRST_PUBLISH_DATE_DESC"] = 120] = "FIRST_PUBLISH_DATE_DESC";
    ArticleSortType[ArticleSortType["LAST_PUBLISH_DATE_ASC"] = 130] = "LAST_PUBLISH_DATE_ASC";
    ArticleSortType[ArticleSortType["LAST_PUBLISH_DATE_DESC"] = 140] = "LAST_PUBLISH_DATE_DESC";
    ArticleSortType[ArticleSortType["CONTENT_LAST_UPDATE_DATE_ASC"] = 150] = "CONTENT_LAST_UPDATE_DATE_ASC";
    ArticleSortType[ArticleSortType["CONTENT_LAST_UPDATE_DATE_DESC"] = 160] = "CONTENT_LAST_UPDATE_DATE_DESC";
})(ArticleSortType || (ArticleSortType = {}));
//# sourceMappingURL=article-sort-type.enum.js.map